/* tslint:disable */
/* eslint-disable */
/**
 * Apperta Physical Health REST API
 * Apperta Physical Health REST API
 *
 * The version of the OpenAPI document: 0.2.0-SNAPSHOT2
 * Contact: info@staircase13.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProcedureTemplateDto } from './ProcedureTemplateDto';
import {
    ProcedureTemplateDtoFromJSON,
    ProcedureTemplateDtoFromJSONTyped,
    ProcedureTemplateDtoToJSON,
} from './ProcedureTemplateDto';

/**
 * Returns a procedure template search
 * @export
 * @interface ProcedureTemplateSearchResponse
 */
export interface ProcedureTemplateSearchResponse {
    /**
     * Search terms which produced results
     * @type {{ [key: string]: string; }}
     * @memberof ProcedureTemplateSearchResponse
     */
    searchTerms?: { [key: string]: string; };
    /**
     * Paging page size
     * @type {number}
     * @memberof ProcedureTemplateSearchResponse
     */
    pageSize?: number;
    /**
     * Paging start record
     * @type {number}
     * @memberof ProcedureTemplateSearchResponse
     */
    start?: number;
    /**
     * Total number of patient profiles
     * @type {number}
     * @memberof ProcedureTemplateSearchResponse
     */
    total?: number;
    /**
     * Ordered by
     * @type {string}
     * @memberof ProcedureTemplateSearchResponse
     */
    orderTerm?: string;
    /**
     * Order direction
     * @type {string}
     * @memberof ProcedureTemplateSearchResponse
     */
    orderDirection?: string;
    /**
     * List of procedure templates items
     * @type {Array<ProcedureTemplateDto>}
     * @memberof ProcedureTemplateSearchResponse
     */
    procedureList?: Array<ProcedureTemplateDto>;
}

/**
 * Check if a given object implements the ProcedureTemplateSearchResponse interface.
 */
export function instanceOfProcedureTemplateSearchResponse(value: object): value is ProcedureTemplateSearchResponse {
    return true;
}

export function ProcedureTemplateSearchResponseFromJSON(json: any): ProcedureTemplateSearchResponse {
    return ProcedureTemplateSearchResponseFromJSONTyped(json, false);
}

export function ProcedureTemplateSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcedureTemplateSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'searchTerms': json['searchTerms'] == null ? undefined : json['searchTerms'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'start': json['start'] == null ? undefined : json['start'],
        'total': json['total'] == null ? undefined : json['total'],
        'orderTerm': json['orderTerm'] == null ? undefined : json['orderTerm'],
        'orderDirection': json['orderDirection'] == null ? undefined : json['orderDirection'],
        'procedureList': json['procedureList'] == null ? undefined : ((json['procedureList'] as Array<any>).map(ProcedureTemplateDtoFromJSON)),
    };
}

export function ProcedureTemplateSearchResponseToJSON(value?: ProcedureTemplateSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'searchTerms': value['searchTerms'],
        'pageSize': value['pageSize'],
        'start': value['start'],
        'total': value['total'],
        'orderTerm': value['orderTerm'],
        'orderDirection': value['orderDirection'],
        'procedureList': value['procedureList'] == null ? undefined : ((value['procedureList'] as Array<any>).map(ProcedureTemplateDtoToJSON)),
    };
}

